export default "__VITE_ASSET__cb2b8cb7__"